module.exports = __webpack_public_path__ + "static/media/asset.1c209f59.png";